"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./ScripCell.style"));

var _hook = require("../../hook");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * ScripCell implements different UIs for types of list data.
 *
 * When a `ref` prop is provided, it will be forwarded to the root element. Any
 * other properties supplied will be provided to the root element (ie, the `as`
 * prop value). This includes all appropriate HTML attributes or aria tags.
 */
const ScripCell = /*#__PURE__*/React.forwardRef(({
  actions,
  as = 'div',
  exchange,
  favorite,
  favoriteAllowed = false,
  graphData,
  onFavorite,
  scripDate,
  scripName,
  selected,
  ltp,
  ltpChange,
  simplifyStyles = false,
  onClick
}, ref) => {
  const variant = (0, _hook.useValueChange)(ltpChange.change);
  const lineGraphVariant = variant === 'auto' ? 'indeterminate' : variant;
  const handleFavoriteClick = React.useCallback(event => {
    event.stopPropagation();
    if (onFavorite) onFavorite(event);
  }, [onFavorite]);
  return (0, _pragma.createFelaElement)(_.View, {
    flex: true,
    onClick: onClick,
    alignItems: "center",
    as: as,
    css: css.root,
    cssProps: {
      actions: !!actions,
      selected,
      simplifyStyles,
      onClick
    },
    padding: !simplifyStyles ? ['xsmall', 'medium'] : [0],
    ref: ref
  }, (0, _pragma.createFelaElement)(_.View, {
    flex: true,
    css: css.wrapper,
    justifyContent: "space-between",
    alignItems: "center"
  }, (0, _pragma.createFelaElement)(_.ScripCellName, {
    exchange: exchange,
    scripDate: scripDate,
    scripName: scripName,
    css: css.name,
    cssProps: {
      hasGraph: !!graphData
    }
  }), graphData && (0, _pragma.createFelaElement)(_.View, {
    "data-name": "graph",
    css: css.graph,
    justifyContent: "center",
    alignItems: "center"
  }, (0, _pragma.createFelaElement)(_.LineGraph, {
    data: graphData,
    fallback: null,
    height: 40,
    variant: lineGraphVariant,
    width: 56
  })), (0, _pragma.createFelaElement)(_.View, {
    "data-name": "scripDetails",
    css: css.scripDetails
  }, ltp !== null ? (0, _pragma.createFelaElement)(_.ScripCellValues, {
    ltp: ltp,
    ltpChange: ltpChange,
    css: css.priceWrapper
  }) : (0, _pragma.createFelaElement)(_.View, {
    css: css.priceWrapper
  }, (0, _pragma.createFelaElement)(_.LoadingBlock, {
    width: 48,
    height: 12
  }), (0, _pragma.createFelaElement)(_.LoadingBlock, {
    width: 64,
    height: 12
  }))), actions && ltp && (0, _pragma.createFelaElement)(_.View, {
    css: css.actions,
    "data-name": "actions"
  }, actions), actions && ltp === null && (0, _pragma.createFelaElement)(_.View, {
    css: css.actions,
    "data-name": "actions"
  }, (0, _pragma.createFelaElement)(_.View, {
    css: css.priceWrapper,
    cssProps: {
      height: '100%'
    }
  }, (0, _pragma.createFelaElement)(_.LoadingBlock, {
    width: 48,
    height: 12
  }), (0, _pragma.createFelaElement)(_.LoadingBlock, {
    width: 64,
    height: 12
  })))), favoriteAllowed && (0, _pragma.createFelaElement)(_.ButtonIcon, {
    "aria-label": "Favorite",
    onClick: handleFavoriteClick,
    variant: "invisible",
    size: "small",
    "data-name": "favourite"
  }, !favorite ? (0, _pragma.createFelaElement)(_.StarInactiveIcon, {
    size: "small"
  }) : (0, _pragma.createFelaElement)(_.StarActiveIcon, {
    size: "small",
    color: "background.yellow"
  })));
});
ScripCell.displayName = 'ScripCell';
var _default = ScripCell;
exports.default = _default;
//# sourceMappingURL=ScripCell.js.map